import { useSpinnerContext } from './SpinnerProvider';

export interface UseSpinnerReturn {
    show: () => void;
    hide: () => void;
    isSpinnerLoading: boolean;
  }

export function useSpinner(): UseSpinnerReturn {
  const { show, hide, isLoading } = useSpinnerContext();

  return {
    show: show,
    hide: hide,
    isSpinnerLoading: isLoading,
  };
}
